import { useState } from 'react'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import { motion } from 'framer-motion'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { CvsDatePicker } from '../../../components'
import * as SnackbarActions from '../../../global/snackbar/snackbar.actions'
import { t } from '@lingui/core/macro'

export const GlobalReport = () => {
  const [loading, setLoading] = useState(false)
  const [startDate, setStartDate] = useState(moment().subtract(7, 'd'))
  const [endDate, setEndDate] = useState(moment())
  const dispatch = useDispatch()

  // This is deprecated. Refer to https://claravine.atlassian.net/browse/CV-3093
  const deprecatedMessage = t`This functionality has been deprecated. Please use the Template Dataset download functionality instead.`

  const download = () => {
    setLoading(false)
    dispatch(
      SnackbarActions.showSnackbar({
        message: deprecatedMessage,
        type: 'INFO',
      }),
    )
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      exit={{ opacity: 0, transition: { duration: 0.5 } }}
    >
      <div style={{ paddingTop: 12 }}>
        <div
          style={{
            height: '60px',
            width: '140px',
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h6"
            style={{ paddingTop: '15px', paddingLeft: '28px', width: '160px' }}
          >
            {t`Global report`}
          </Typography>
        </div>
      </div>
      <div style={{ padding: 24 }}>
        <div
          style={{
            display: 'flex',
            gap: '15px',
            alignItems: 'center',
            marginBottom: 24,
          }}
        >
          <div>
            <CvsDatePicker
              color="primary"
              margin="dense"
              inputFormat="YYYY-MM-DD"
              label={t`Start date`}
              handleChange={setStartDate}
              value={startDate}
            />
          </div>
          <div>
            <CvsDatePicker
              color="primary"
              margin="dense"
              inputFormat="YYYY-MM-DD"
              label={t`End date`}
              handleChange={setEndDate}
              value={endDate}
            />
          </div>
          <div style={{ flexShrink: 1 }}>
            <Button
              disabled={loading}
              variant="contained"
              color="primary"
              size="large"
              onClick={download}
            >
              {t`Download`}
            </Button>
          </div>
        </div>
        {loading && (
          <div style={{ padding: 24, textAlign: 'center' }}>
            <CircularProgress />
          </div>
        )}
        <Typography variant="caption">{deprecatedMessage}</Typography>
      </div>
    </motion.div>
  )
}
